<template>

 <section id="services-section">
      <div class="container">
        <div class="title-section">
          <h1>{{data.title}}</h1>
          <span></span>
          <p>{{data.subtitle}}</p>
          <br>
          <a :href="'#'+data.bottom_href+'-section'" class="default-button scroll-btn">{{data.bottom_title}}</a>
        </div>

        <div class="services-box">
          <div class="row">
            <div class="col-md-6" v-for="(item, index) in data.qualities">
              <div class="services-post">
                <a href="#"><i :class="'fa '+item.icon"></i></a>
                <h2>{{item.title}}</h2>
                <p>{{item.subtitle}}</p>
              </div>
            </div>
    
          </div>
        </div>

      </div>
    </section>
</template>

<script>
export default {
  name: 'Services',
    props: {
    data: Object
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
